import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface HeatmapPoint {
    subject: string;
    mastery: number;
    uncertainty: number;
}

interface StreakData {
    current: number;
    best: number;
}

interface DashboardState {
    heatmap: HeatmapPoint[];
    streaks: StreakData;
}

const initialState: DashboardState = {
    heatmap: [],
    streaks: { current: 0, best: 0 }
};

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        setHeatmap(state: DashboardState, action: PayloadAction<HeatmapPoint[]>) {
            state.heatmap = action.payload;
        },
        setStreaks(state: DashboardState, action: PayloadAction<StreakData>) {
            state.streaks = action.payload;
        }
    }
});

export const { setHeatmap, setStreaks } = dashboardSlice.actions;
export default dashboardSlice.reducer;
